'use client'
// import { useNavigate } from 'react-router-dom'
// import { useRouter } from 'next/navigation'
import axios from '../utils/axiosConfig'
import useAuth from './useAuth'
// Add import for useNotification to handle user notifications on logout errors
import { useNotification } from '../context/NotificationProvider'

// Custom hook for handling user logout functionality
// Manages authentication state reset, local storage cleanup, and server-side logout
const useLogout = () => {
  // Extract setAuth and setPersist functions from useAuth hook to clear authentication and persistence state
  const { setAuth, setPersist } = useAuth()
  // Get router instance for programmatic navigation after logout
  // const router = useRouter()
  // Get notification function to show user feedback on errors
  const { showNotification } = useNotification()

  // Async function to perform logout operations
  // Clears client-side auth state, removes persisted data, calls server logout, and redirects
  const logout = async () => {
    // First, disable persistence and remove from localStorage to prevent token refresh
    setPersist(false)
    localStorage.removeItem('persist')
    // Then clear authentication state
    setAuth(null)
    try {
      // Make server-side logout request with credentials to invalidate session
      await axios.get('/users/logout', {
        withCredentials: true,
      })
      // Reload the page to ensure clean state after logout
      window.location.href = '/'
    } catch (error) {
      // Log error for debugging purposes
      console.error('Logout error:', error)
      // Show user-friendly error notification
      showNotification('Logout failed. Please try again.', 'error')
    }
  }

  // Return the logout function for use in components
  return logout
}

export default useLogout
